import { Divider as AntdDivider } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

/**
 * Primary UI component for user interaction
 */
const Divider = ({ dashed, plain, orientation, type, ...props }) => {
  return (
    <AntdDivider dashed={dashed} plain={plain} orientation={orientation} type={type} {...props}>
      {props.children}
    </AntdDivider>
  );
};

Divider.propTypes = {
  dashed: PropTypes.bool,
  plain: PropTypes.bool,
  orientation: PropTypes.string,
  type: PropTypes.string,
};

export { Divider };
